import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_312_4612)">
      <path
        d="M5.67875 10.7159C8.45988 10.7159 10.7144 8.46135 10.7144 5.68022C10.7144 2.89908 8.45988 0.644531 5.67875 0.644531C2.89762 0.644531 0.643066 2.89908 0.643066 5.68022C0.643066 8.46135 2.89762 10.7159 5.67875 10.7159Z"
        fill="white"
        stroke={props?.stroke || '#B3B3B3'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.357 11.3564L9.24268 9.24219"
        stroke={props?.stroke || '#B3B3B3'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_312_4612">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const GlassIcon = memo(ForwardRef);
export default GlassIcon;
